import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        stack: {
            gap: ['medium.base', 'medium.sm', 'medium.md', 'small.lg'],
        },
        panel: {
            marginTop: remCalc(22),
        },
        accordionItem: {
            margin: 0,
            paddingTop: {
                base: 'unset',
                sm: 'unset',
                md: 'xsmall-1.base',
                lg: 'xsmall-1.base',
            },
            paddingBottom: 'xsmall-1.base',
            borderStyle: 'solid',
        },
        item: {
            display: 'flex',
            flexDir: 'row',
            justifyContent: 'space-between',
            padding: 0,
            _hover: {bg: 'unset'},
        },
        headerText: {
            color: 'text.default',
            textStyle: 'body-large',
            fontWeight: 'medium',
        },
        headerTextAccordion: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            cursor: 'pointer',
            textAlign: 'left',
            color: 'foreground.neutral.default',
        },
        text: {
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'regular',
        },
        button: {
            borderColor: 'border.light',
            cursor: 'pointer',
            _hover: {bg: 'unset'},
        },
        menuItem: {
            paddingX: remCalc(20),
            paddingY: remCalc(8),
            display: 'block',
            float: 'right',
            width: '100%',
            background: 'background.base.elevated',
        },
        radio: {
            justifyContent: 'space-between',
            flexDirection: 'row',
            width: '100%',
            borderWidth: remCalc(0.6),
        },
        radioDrawer: {
            cursor: 'pointer',
            borderWidth: remCalc(0.6),
        },
    },
    variants: {
        sortByButton: {
            menuContainer: {
                display: 'flex',
                flexDir: 'column',
                alignItems: 'flex-start',
                width: '100%',
                padding: 0,
                // gap: remCalc(16),
            },
            item: {
                w: '100%',
                h: 'auto',
                alignItems: 'center',
                gap: remCalc(8),
                alignSelf: 'stretch',
            },
            itemIconContainer: {
                w: 'iconsSize.medium',
                h: 'iconsSize.medium',
                justifyContent: 'center',
                alignItems: 'center',
            },
        },
    },
}
